var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00037 1.11133C4.4936 0.436512 3.68666 0 2.77778 0C1.24365 0 0 1.24365 0 2.77778C0 3.68655 0.436407 4.4934 1.11108 5.00018V14.9997C0.436407 15.5065 0 16.3133 0 17.2221C0 18.7562 1.24365 19.9999 2.77778 19.9999C3.68642 19.9999 4.49316 19.5636 4.99996 18.8891H15.0001C15.5069 19.5636 16.3136 19.9999 17.2222 19.9999C18.7564 19.9999 20 18.7562 20 17.2221C20 16.3133 19.5636 15.5064 18.8889 14.9997V5.00023C19.5636 4.49345 20 3.68658 20 2.77778C20 1.24365 18.7564 0 17.2222 0C16.3134 0 15.5064 0.436512 14.9996 1.11133H5.00037ZM3.11108 5.53576C4.3787 5.38418 5.38404 4.37891 5.53574 3.11133H14.4643C14.616 4.37889 15.6213 5.38414 16.8889 5.53576V14.4641C15.6211 14.6158 14.6157 15.6213 14.4642 16.8891H5.5358C5.38433 15.6213 4.37888 14.6157 3.11108 14.4641V5.53576Z",
    fill: "#F5F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoords);
export default __webpack_public_path__ + "static/media/icon-coords.e28fb8a12dc26859235d5ec14f8bd17b.svg";
export { ForwardRef as ReactComponent };